import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-leave-calendar',
    templateUrl: './leave-calendar.component.html',
    styleUrls: ['./leave-calendar.component.scss'],
    standalone: false
})
export class LeaveCalendarComponent implements OnInit {
  currentDate: Date;
  currentMonth: number;
  currentYear: number;
  days: string[];
  currentMonthYear :string;
  dates: Date[];
  selectedDate: Date; // Add a property to store the selected date
  startDate: Date;
  endDate: Date;

  constructor( ) {

  }
  ngOnInit() {
    this.currentDate = new Date();
    this.currentMonth = this.currentDate.getMonth();
    this.currentYear = this.currentDate.getFullYear();
    this.currentMonthYear = this.currentDate.toLocaleString('default', { month: 'long', year: 'numeric' }); // Initialize currentMonthYear
    this.initializeCalendar();
  }

  initializeCalendar(): void {
    this.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    this.generateDates();
  }

  generateDates(): void {
    this.dates = [];
    const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1);
    const lastDayOfMonth = new Date(this.currentYear, this.currentMonth + 1, 0);
    const daysInMonth = lastDayOfMonth.getDate();
    const startingDay = firstDayOfMonth.getDay();
    for (let i = 0; i < startingDay; i++) {
      this.dates.push(null);
    }
    for (let i = 1; i <= daysInMonth; i++) {
      this.dates.push(new Date(this.currentYear, this.currentMonth, i));
    }
  }

  dateClicked(date: Date): void {
    if (!this.startDate || (this.startDate && this.endDate)) {
      this.startDate = date;
      this.endDate = null;
    } else if (date < this.startDate) {
      this.endDate = this.startDate;
      this.startDate = date;
    } else {
      this.endDate = date;
    }
  }
  
  isDateInRange(date: Date): boolean {
    if (!this.startDate || !this.endDate) {
      return false;
    }
    console.log("Date in range", this.startDate);
    console.log("Date in end range", this.endDate)
    return date >= this.startDate && date <= this.endDate;
   
  }
  

  prevMonth(): void {
    this.currentMonth--;
    if (this.currentMonth < 0) {
      this.currentYear--;
      this.currentMonth = 11;
    }
    this.currentMonthYear = new Date(this.currentYear, this.currentMonth).toLocaleString('default', { month: 'long', year: 'numeric' }); // Update currentMonthYear
    this.generateDates();
  }
  
  nextMonth(): void {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentYear++;
      this.currentMonth = 0;
    }
    this.currentMonthYear = new Date(this.currentYear, this.currentMonth).toLocaleString('default', { month: 'long', year: 'numeric' }); // Update currentMonthYear
    this.generateDates();
  }


  isDateSelected(date: Date): boolean {
    return this.selectedDate && this.selectedDate.getTime() === date.getTime();
  }







}
